// extracted by mini-css-extract-plugin
export default {"rangeSlider":"index_rangeSlider__VCih6","inputSpacer":"index_inputSpacer__rUxLD"};